// src/index.ts
import HttpClient from "./core/HttpClient.mjs";
export * from "./core/HttpClient.mjs";
var src_default = new HttpClient();
export {
  HttpClient,
  src_default as default
};
